import { render, staticRenderFns } from "./companyYearReport.vue?vue&type=template&id=2bfb0dd6&scoped=true&"
import script from "./companyYearReport.vue?vue&type=script&lang=js&"
export * from "./companyYearReport.vue?vue&type=script&lang=js&"
import style0 from "./companyYearReport.vue?vue&type=style&index=0&id=2bfb0dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfb0dd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfb0dd6')) {
      api.createRecord('2bfb0dd6', component.options)
    } else {
      api.reload('2bfb0dd6', component.options)
    }
    module.hot.accept("./companyYearReport.vue?vue&type=template&id=2bfb0dd6&scoped=true&", function () {
      api.rerender('2bfb0dd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/companyYearReport.vue"
export default component.exports